
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 76 76"><path fill="currentColor" d="M71.996 20.352C68.513 8.34 81.036 2.105 84.451.662c-6.63-.198-11.786.13-16.406 1.575-8.907 2.428-14.732 8.4-24.442 22.118l5.223 17.262 11.451-11.814 4.419 14.9L34.63 75.681c35.022 0 47.276-16.278 43.928-29.864l-6.562-25.466Z" style="opacity:.8"/><path fill="currentColor" d="m38.781 51.987-5.223-17.261L22.107 46.54l-4.42-14.9L47.754.597C12.732.596.478 16.873 3.826 30.459l6.629 25.532C13.937 68.002 1.415 74.238-2 75.681c6.629.197 11.786-.13 16.406-1.575 8.84-2.428 14.665-8.4 24.375-22.118Z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    